<template>
  <b-card no-body>
    <b-card-header class="border-0">
      <h3 class="mb-0">{{ $t("message.my_pages") }}</h3>
    </b-card-header>
    <div class="loader" v-if="loading"></div>
    <el-table class="table-responsive table" header-row-class-name="thead-light" :data="orders">
      <el-table-column :label="$t('message.any_company')" min-width="100px" prop="ev_foretag">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">
                {{
                row.bestForetag
                }}
              </span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      <!--
      <el-table-column label="Firstname" min-width="100px" prop="firatname">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.bestFnamn
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column label="Lastname" min-width="100px" prop="lastname">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">{{
                row.bestEnamn
              }}</span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
      -->
      <el-table-column label="" min-width="100px" prop="status">
        <template v-slot="{ row }">
          <badge v-if="row.isrefer == 1" class="badge-dot mr-4" type>
            <span class="label_seb">SEB</span>
          </badge>
        </template>
      </el-table-column>

      <el-table-column :label="$t('message.status')" min-width="100px" prop="status">
        <template v-slot="{ row }">
          <badge v-if="row.endDate" class="badge-dot mr-4" type>
            <i :class="`bg-success`"></i>
            <span class="status" :class="`text-success`">{{ $t("message.completed") }}</span>
          </badge>
          <badge v-else class="badge-dot mr-4" type>
            <i :class="`bg-warning`"></i>
            <span class="status" :class="`text-warning`">{{ $t("message.pending") }}</span>
          </badge>
        </template>
      </el-table-column>

      <el-table-column :label="$t('message.start_date')" min-width="100px" prop="startdate">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">
                {{
                row.startDate
                }}
              </span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column :label="$t('message.end_date')" min-width="100px" prop="enddate">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <span class="font-weight-600 name mb-0 text-sm">
                {{
                row.endDate
                }}
              </span>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>

      <el-table-column :label="$t('message.action')" min-width="150px" prop="action">
        <template v-slot="{ row }">
          <b-media no-body class="align-items-center">
            <b-media-body>
              <base-button v-on:click="vieworder(row.id)" icon type="primary">
                <span class="btn-inner--icon">
                  <i class="ni ni-briefcase-24"></i>
                </span>
                <span class="btn-inner--text">{{ $t("message.view") }}</span>
              </base-button>
              <base-button
                v-if="row.endDate"
                v-on:click="copyorder(row.id,row.orderToken)"
                icon
                type="primary"
              >
                <span class="btn-inner--icon">
                  <i class="ni ni-single-copy-04"></i>
                </span>
                <span class="btn-inner--text">{{ $t("message.kopia") }}</span>
              </base-button>
            </b-media-body>
          </b-media>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <b-pagination
        v-on:input="pagechanged"
        v-model="currentPage"
        :per-page="10"
        :total-rows="orderscount"
      ></b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";
import qs from "qs";
import VueAxios from "vue-axios";
import projects from "./../projects";
import { Table, TableColumn } from "element-ui";
Vue.use(VueAxios, axios);
//Vue.$cookies.config("30d");
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      projects,
      orders: [],
      currentPage: 1,
      loading: true,
      orderscount: 0
    };
  },
  mounted() {
    if ($cookies.isKey("userid")) {
      this.get_orders();
    } else {
      //login
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    copyorder: function(orderid, orderToken) {
      var userid = $cookies.get("userid");
      var token = $cookies.get("token");
      Vue.axios
        .post(
          "/app/copy_survey",
          qs.stringify({
            order_id: orderid,
            order_token: orderToken,
            userid: userid,
            token: token
          })
        )
        .then(({ data }) => {
          this.get_orders();
          console.log("copy new row");
        });
    },
    vieworder: function(orderid) {
      console.log("orderid " + orderid);
      this.$router.push({ name: "order_detail", params: { id: orderid } });
    },
    pagechanged: function() {
      console.log("hi");
      console.log(this.currentPage);
      this.loading = true;
      var userid = $cookies.get("userid");
      var token = $cookies.get("token");
      if (userid == 11) {
        userid = 0;
      }
      Vue.axios
        .get("/app/getorders/" + userid + "/" + token + "/" + this.currentPage)
        .then(({ data }) => {
          if (data.status == 1) {
            this.loading = false;
            console.log(data.orders);
            this.orders = data.orders;
            this.orderscount = data.count;
          }
          this.loading = false;
          //code
        });
    },
    get_orders: function() {
      var userid = $cookies.get("userid");
      var token = $cookies.get("token");
      if (userid == 11) {
        userid = 0;
      }
      Vue.axios
        .get("/app/getorders/" + userid + "/" + token)
        .then(({ data }) => {
          if (data.status == 1) {
            this.loading = false;
            console.log(data.orders);
            this.orders = data.orders;
            this.orderscount = data.count;
          }
          this.loading = false;
          //code
        });
    }
  }
};
</script>
<style scoped>
.label_seb{
  background-color: #000;
  color: #fff;
  padding: 10px;
  border-radius: 10rem;
}
.loader {
  /* Loader Div Class */
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  background-color: #cecece;
  background-image: url("../../../assets/ajax-loader.gif");
  background-size: 300px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
</style>